import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'
import type { BigNumber } from 'bignumber.js'

type Props = {
  ticker: string
  priceUsd: BigNumber
} & ClassNameProps

export const WalletAssetItemPrice: React.FC<Props> = ({
  ticker,
  priceUsd,
  className,
}) => {
  const renderTicker = ticker.length > 6 ? ticker.slice(0, 4) + '…' : ticker

  return (
    <Price className={className}>
      1 ${renderTicker} ={' '}
      <Numeric value={priceUsd} preset="currency-amount-short" currency="$" />
    </Price>
  )
}

const Price = styled.div`
  color: var(--text-7);
  text-align: start;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
